import * as Yup from "yup";

const servicoValidator = Yup.object().shape({
  nome: Yup.string().nullable().required("Nome"),
  descricao: Yup.string().nullable().required("Descrição"),
  grupoServicoId: Yup.number().nullable().required("Grupo de Serviço"),
  precoServico: Yup.mixed().test(
    "is-number",
    "Preco de serviço maior que zero",
    (value) => value && !isNaN(Number(value)) && Number(value) > 0,
  ),
});

export default servicoValidator;
